export const MASCOT_URL = "/professor-flux.png";

export const FluxMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 60 60" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <line x1="30" y1="8" x2="30" y2="28" stroke="#f59e0b" strokeWidth="4" strokeLinecap="round" />
    <line x1="12" y1="48" x2="27" y2="32" stroke="#f59e0b" strokeWidth="4" strokeLinecap="round" />
    <line x1="48" y1="48" x2="33" y2="32" stroke="#f59e0b" strokeWidth="4" strokeLinecap="round" />
    <circle cx="30" cy="30" r="12" fill="#f59e0b" opacity="0.15" />
    <circle cx="30" cy="30" r="8" fill="#f59e0b" opacity="0.35" />
    <circle cx="30" cy="30" r="5.5" fill="#f59e0b" />
    <circle cx="30" cy="30" r="2.2" fill="#ffffff" />
  </svg>
);

export const AtomicDecor = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" fill="none" className={`pointer-events-none ${className}`} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="100" cy="100" rx="90" ry="40" stroke="#f59e0b" strokeWidth="0.5" opacity="0.2" transform="rotate(-30 100 100)" />
    <ellipse cx="100" cy="100" rx="90" ry="40" stroke="#2dd4bf" strokeWidth="0.5" opacity="0.15" transform="rotate(30 100 100)" />
    <ellipse cx="100" cy="100" rx="90" ry="40" stroke="#f59e0b" strokeWidth="0.5" opacity="0.1" transform="rotate(90 100 100)" />
    <circle cx="100" cy="100" r="3" fill="#f59e0b" opacity="0.6" />
    <circle cx="190" cy="100" r="2" fill="#f59e0b" opacity="0.4" />
    <circle cx="10" cy="100" r="2" fill="#2dd4bf" opacity="0.3" />
    <circle cx="100" cy="60" r="1.5" fill="#f59e0b" opacity="0.3" />
    <circle cx="100" cy="140" r="1.5" fill="#2dd4bf" opacity="0.25" />
  </svg>
);

export const Starburst = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={`pointer-events-none ${className}`} xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="2" x2="20" y2="38" stroke="#f59e0b" strokeWidth="1" opacity="0.4" />
    <line x1="2" y1="20" x2="38" y2="20" stroke="#f59e0b" strokeWidth="1" opacity="0.4" />
    <line x1="6" y1="6" x2="34" y2="34" stroke="#f59e0b" strokeWidth="0.5" opacity="0.25" />
    <line x1="34" y1="6" x2="6" y2="34" stroke="#f59e0b" strokeWidth="0.5" opacity="0.25" />
    <circle cx="20" cy="20" r="2" fill="#f59e0b" opacity="0.6" />
  </svg>
);

export const TimelineRail = () => (
  <div className="flex items-center gap-2 opacity-30">
    <div className="w-2 h-2 rounded-full bg-[#f59e0b]" />
    <div className="h-px flex-1 bg-gradient-to-r from-[#f59e0b] via-[#f59e0b]/40 to-transparent" />
    <div className="w-1.5 h-1.5 rounded-full bg-[#2dd4bf]" />
    <div className="h-px flex-1 bg-gradient-to-r from-[#2dd4bf]/40 to-transparent" />
    <div className="w-1 h-1 rounded-full bg-[#f59e0b]/60" />
  </div>
);
